/**
 * Custom JS - Linked Variant Options
 * Handles syncing of variant options based on configuration from Liquid.
 * 
 * Logic:
 * 1. Listen for 'change' events on variant inputs (captured at the document level).
 * 2. Identify the form associated with the changed input.
 * 3. Aggregate 'linked-options' configuration from all variant-picker components belonging to that form.
 * 4. Check if the changed option triggers a watcher (another option that should match its value).
 * 5. If a match is found, find the corresponding input for the watcher option (matching by data-value-name).
 * 6. Update the watcher input's 'checked' state to match the changed option.
 * 7. Do NOT dispatch a second 'change' event. The theme's native event listener (running on bubbling phase)
 *    will pick up the valid state of all checked inputs (including our auto-updated one) and perform a single fetch/render.
 */

document.addEventListener('change', function(event) {
  // 1. Filter for variant inputs
  if (!event.target.matches('input[data-option-position]')) {
    return;
  }

  const input = event.target;
  const formId = input.getAttribute('form');
  
  // 2. Safely parse configuration from ALL variant pickers sharing this form
  const linkedOptions = getLinkedOptions(input);
  
  if (Object.keys(linkedOptions).length === 0) return;

  try {
    const changedOptionPosition = String(input.dataset.optionPosition);
    const changedOptionValueName = input.dataset.valueName; 

    if (!changedOptionPosition || !changedOptionValueName) return;

    // 3. Iterate watchers
    Object.keys(linkedOptions).forEach(watcherOptionPosition => {
      const sourceOptionPosition = String(linkedOptions[watcherOptionPosition]);

      // Check if this watcher is interested in the changed option
      if (sourceOptionPosition === changedOptionPosition) {
        
        // 4. Find the watcher input with matching value name
        // Scope search to inputs sharing the same form ID and ensure we find the specific option position
        const watcherInputs = Array.from(document.querySelectorAll(`input[data-option-position="${watcherOptionPosition}"][form="${formId}"]`));
        const matchingInput = watcherInputs.find(i => i.dataset.valueName === changedOptionValueName);

        if (matchingInput && !matchingInput.disabled && !matchingInput.checked) {
          // Sync the option
          matchingInput.checked = true;
          
          // Note: We intentionally do NOT dispatch a new change event here.
          // Since we use the capture phase, this update happens BEFORE the theme's own change handler runs.
          // The theme will read the DOM, see this input is now checked, and send the correct combination to the server.
        }
      }
    });

  } catch (e) {
    console.error('CustomJS Error parsing linked options:', e);
  }
}, true); // Use capture phase to ensure this runs before theme.js delegate

/**
 * Helper to aggregate linked options from multiple variant-picker blocks
 * that might belong to the same product form.
 */
function getLinkedOptions(input) {
    const variantPickers = document.querySelectorAll('variant-picker');
    let mergedOptions = {};
    const formId = input.getAttribute('form');

    variantPickers.forEach(picker => {
        // Check if this picker belongs to the same form by comparing form IDs
        if (picker.getAttribute('form-id') === formId && picker.dataset.linkedOptions) {
             try {
                 const options = JSON.parse(picker.dataset.linkedOptions);
                 Object.assign(mergedOptions, options);
             } catch (e) {}
        }
    });
    return mergedOptions;
}
